
export default [

        {
            path:'/inter898',
            name:'inter898',
            component:() => import('@/views/inter898/inter898'),
            meta: {
    
                keepAlive: true, //此组件需要被缓存
                isBack:false,
            }
        },
        {
            path:'/inter898-list',
            name:'inter898-list',
            component:() => import('@/views/inter898/inter898-list'),
            meta: {
    
                keepAlive: true, //此组件需要被缓存
                isBack:false,
            }
        },
        
]


// WEBPACK FOOTER //
// ./src/router/inter898.js